import { useEffect, useRef } from "react";
import { Button, Container } from "react-bootstrap";

export const SubmitSuccess = () => {
  const myRef = useRef(null);
  const executeScroll = () => window.scrollTo(0, 0);
  useEffect(() => {
    executeScroll();
    setTimeout(pageRedirect, 5000);
  });

  function pageRedirect() {
    window.location.replace("https://codev.utahcounty.gov/fire-marshal");
  }

  return (
    <Container ref={myRef} className='component mt-5 text-center'>
      <h1 className='mb-4'>Application Successfully Submitted</h1>
      <p className='mb-4'>
        Your permit application has been successfuly submitted to the Fire Marshal's Office and will be reviewed for
        approval. Thank you for your submisssion.{" "}
      </p>
      <div className='ButtonCenter'>
        <Button size='lg' href='https://codev.utahcounty.gov/fire-marshal'>
          Return to Home
        </Button>
      </div>
    </Container>
  );
};
